import React from "react";
import SectionOne from "./component/sectionOne";
import SectionTwo from "./component/sectionTwo";
import SectionThree from "./component/sectionThree";
import SectionFour from "./component/sectionFour";
import SectionFive from "./component/sectionFive";
import SectionSix from "./component/sectionSix";
import Faq from "./component/faq";
import Footer from "./component/footer";
import BlogComp from "./component/blogcomp";
import Navbar from "../../components/navbar";

const HomePage = () => {
  return (
    <div>
      {" "}
      <Navbar />
      <SectionOne />
      <SectionTwo />
      <SectionThree />
      <SectionFour />
      <SectionFive />
      <SectionSix />
      <BlogComp />
      <Faq />
      <Footer />
    </div>
  );
};

export default HomePage;
